import * as React from "react";
import { TextField } from "@mui/material";
import ConfirmModal from "./confirm.modal";
import type { ModalComponentProps } from "../../types/modal.types";

interface TextFieldProps extends ModalComponentProps {
  title?: string;
  value?: string;
  click?: (value: string) => void;
  changeValue?: (value: string) => void;
  useTextArea?: boolean;
  pattern?: string;
  helper?: string;
}

export default function TextFieldModal(props: TextFieldProps) {
  const { id, onClose, title, click, changeValue, value = "", pattern = "", helper = "" } = props;

  const [text, setText] = React.useState(value);
  const [error, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState("");

  const validate = (value: string) => {
    if (pattern) {
      try {
        // pattern에 슬래시(/.../)가 들어왔을 경우 제거
        const cleanedPattern = pattern.replace(/^\/|\/$/g, "");
        const regex = new RegExp(cleanedPattern);

        if (!regex.test(value)) {
          setError(true);
          setHelperText(helper);
        } else {
          setError(false);
          setHelperText("");
        }
      } catch (e) {
        console.error("❌ Invalid RegExp pattern:", pattern);
        setError(true);
        setHelperText("올바르지 않은 패턴입니다.");
      }
    } else {
      setError(false);
      setHelperText("");
    }
  }

  return (
    <ConfirmModal
      title={`${title} 수정`}
      onClose={onClose}
      rightButton={{
        title: "저장",
        disabled: error,
        onClick: () => {
          click?.(text);
          onClose?.();
        },
      }}
      id={id}
    >
      <div className="mt-[16px]">
        <TextField
          className="w-[552px]"
          label={`${title}*`}
          value={text}
          error={error}
          helperText={helperText}
          onChange={(e) => {
            const { value } = e.target;
            changeValue?.(value);
            setText(value);
            validate(value)
          }}
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              sx: {
                height: props.useTextArea ? 200 : 52,
                alignItems: "flex-start"
              }
            }
          }}
        />
      </div>
    </ConfirmModal>
  );
};
